import React from 'react';
import RewardSections from '../../components/UFO/reward/index';  // ✅ Fix import

const RewardPage = () => {
  return (
    <>
      <RewardSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default RewardPage;